var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 10,
    viewBox: "0 0 9 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.429H0m4.5-4.5v9"
  })));
}

export default __webpack_public_path__ + "e3a82e78e03d0553f569865f1e45bab9.svg";
export { SvgPlus as ReactComponent };